import { useContext } from 'react'

import { LayoutContext } from '..'

export const useLayout = () => useContext(LayoutContext)
